import { createAsyncThunk } from '@reduxjs/toolkit';
import CompanySettingsServices from '@/services/CompanySettingsServices';

const handler = (name, asyncFunction) =>
  createAsyncThunk(`CompanySettings/${name}`, async (arg) => {
    const data = await asyncFunction(arg);
    return data;
  });

export const getCompanySettings = handler(
  'getCompanySettings',
  CompanySettingsServices.getCompanySettings
);

export const getWatermarkSettings = handler(
  'getWatermarkSettings',
  CompanySettingsServices.getWatermarkSettings
);

export const updateWatermarkSettings = handler(
  'updateWatermarkSettings',
  CompanySettingsServices.updateWatermarkSettings
);

export const getTimezones = handler(
  'getTimezones',
  CompanySettingsServices.getTimezones
);

export const updateCompanySettings = handler(
  'updateCompanySettings',
  CompanySettingsServices.updateCompanySettings
);

export const uploadCompanyImages = handler(
  'uploadCompanyImages',
  CompanySettingsServices.uploadCompanyImages
);

export const regenerateApiKey = handler(
  'regenerateApiKey',
  CompanySettingsServices.regenerateApiKey
);
